<template>
  <div id="school">
    <!-- 头部图片 -->
    <div class="banner">
      <div class="">
        <div class="text"><span class="block">震惊！两个月，变现3700万，</span><span class="block">会玩私域流量的企业，到底有多猛？</span></div>
        <div class="text">透析微信安全临界点，紧握业绩生命脉搏</div>
      </div>
    </div>
    <!-- 序节 -->
    <div class="foreword-section">
      <div class="title-image"></div>
      <div class="content">
        <div class="text-title">
          <span class="">流量成本越来越高，</span>
          <span class="">建立私域流量池势在必行！</span>
        </div>
        <div class="text-content">
          2019年，企业竞争更加激烈，网络推广费水涨船高。微薄的利润在高昂的广告费前显得苍白。企业为降低外购流量的营销成本，开始重视用户运营，构建企业私域流量池，通过微信及社群运营，逐步积累掌控在自己手中的“无形资产”。
        </div>
      </div>
    </div>
    <!-- 问题 -->
    <div class="question-list">
      <div class="question-wrap">
        <div class="title">
          <span class="text">运营难题哪一个困扰着您 <span class="sign">，</span></span>
          <span class="text">我们全方位为您贴心服务</span>
        </div>
        <div class="babel-list">
          <span class="babel-nav"
                :class="{'active': serveIndex === 1}"
                @click="serveIndex = 1">团队组建</span>
          <span class="babel-nav"
                :class="{'active': serveIndex === 2}"
                @click="serveIndex = 2">微信引流</span>
          <span class="babel-nav"
                :class="{'active': serveIndex === 3}"
                @click="serveIndex = 3">内容运营</span>
          <span class="babel-nav"
                :class="{'active': serveIndex === 4}"
                @click="serveIndex = 4">安全策略</span>
          <span class="babel-nav"
                :class="{'active': serveIndex === 5}"
                @click="serveIndex = 5">成交变现</span>
          <span class="babel-nav"
                :class="{'active': serveIndex === 6}"
                @click="serveIndex = 6">风控管理</span>
        </div>
        <div class="answer-list">
          <transition-group name="answer" class="answer-wrap">
            <div :key="1" class="answer" v-if="serveIndex === 1">
              <div class="answer-image img-1"></div>
              <div class="answer-info">
                <span class="big-title">不懂团队组建？</span>
                <span class="text small-title">我们有，</span>
                <span class="text content">我们的导师精通微营销团队常见部门架构，微营销团队个性化激励方案，微信团队每日必做工作拆解等，帮您快速建立一支超强战斗力的微营销团队，帮助企业获得更高利润。</span>
              </div>
            </div>
            <div :key="2" class="answer" v-else-if="serveIndex === 2">
              <div class="answer-image img-2"></div>
              <div class="answer-info">
                <span class="big-title">不懂引流？</span>
                <span class="text small-title">我们有，</span>
                <span class="text content">我们导师对把大量手机号码变成微信好友，公众号与个人号相互导流、SEM及信息流广告投放等玩法轻车熟路，至少帮你节省3年时间，助你少走弯路，最短时间吸引更多优质流量。</span>
              </div>
            </div>
            <div :key="3" class="answer" v-else-if="serveIndex === 3">
              <div class="answer-image img-3"></div>
              <div class="answer-info">
                <span class="big-title">不懂内容运营？</span>
                <span class="text small-title">我们有，</span>
                <span class="text content">我们专业导师传授与时俱进的微信运营方法，朋友圈内容策划、质检，客户管理，社群运营及各类辅助工具的运用。帮你快速获取客户信任，实现用户增长沉淀，暴增销售业绩。</span>
              </div>
            </div>
            <div :key="4" class="answer" v-else-if="serveIndex === 4">
              <div class="answer-image img-4"></div>
              <div class="answer-info">
                <span class="big-title">不懂安全策略？</span>
                <span class="text small-title">我们有，</span>
                <span class="text content">我们导师深度了解腾讯封号的最新规则和逻辑，将与你分享微信注册前后的操作细节，明确在运营阶段的封号陷阱，预防微信被判定营销号被降权封停，总结微信号解封的重重困境和解封方法。</span>
              </div>
            </div>
            <div :key="5" class="answer" v-else-if="serveIndex === 5">
              <div class="answer-image img-5"></div>
              <div class="answer-info">
                <span class="big-title">不懂成交变现？</span>
                <span class="text small-title">我们有，</span>
                <span class="text content">我们的导师精通私域流量转化，教你快速掌握微信客户沟通的8大独特技巧，及微信销售的6大优势，提升员工望闻问切快速成交技能，挖掘客户终身价值，实现粉丝快速高价值变现。</span>
              </div>
            </div>
            <div :key="6" class="answer" v-else>
              <div class="answer-image img-6"></div>
              <div class="answer-info">
                <span class="big-title">不懂风控管理？</span>
                <span class="text small-title">我们有，</span>
                <span
                  class="text content">我们的导师教你微信QC体系的搭建，以及如何制作流量转化数据模型风控广告成本。分享如何对员工与客户的聊天内容进行风控，避免客户投诉导致的封号及企业运营风险。</span>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <!-- 师资团队 -->
    <div class="teacher-list">
      <div class="teacher-list-wrap">
        <div class="title_1">
          <div class="text"><span class="block">豪华讲师团汇聚，</span><span class="block">实战经验倾囊相授，</span><span class="block">满足不同企业需求</span></div>
          <div class="text"><span class="block">带你0基础入门到精通，</span><span class="block">微信生态赋能企业</span></div>
        </div>
        <div class="teachers-wrap">
          <div class="left-teacher">
            <div class="teacher-image"></div>
            <div class="teacher-info">
              <span class="name">成莹</span>
              <span class="position">奥创学院金牌导师</span>
              <span
                class="info">10年电商行业经验，5年持续微营销运营，微营销过亿团队核心创始人；受邀为新东方在线教育，学而思集团，中大英才网络教育，学霸君集团，鱼塘科技等企业做专业讲课和培训</span>
            </div>
          </div>
          <div class="right-teacher">
            <div class="teacher-info">
              <span class="name">马娜</span>
              <span class="position">奥创学院金牌导师</span>
              <span class="info">奥创软件研究院金牌讲师，千万团队精细化管理特聘导师，微信引流超级吸粉大咖；受邀为正保远程教育，学霸君集团，小邦规划等企业做专业讲课和培训</span>
            </div>
            <div class="teacher-image"></div>
          </div>
        </div>
        <div class="all-teacher">
          <img class="img" src="./image/photo.png" alt="">
        </div>
        <div class="title_2">
          <span class="text">
            <span class="block">奥创严选学员企业资质，</span>
            <span class="block">你遇到的问题可能别人已经完美解决，</span>
            <span class="block">别人遇到的问题，</span>
          </span>
          <span class="text">
            <span class="block">可能明天你也将遇到。</span>
            <span class="block">通过深度学习交流，</span>
            <span class="block">可提前避坑不踩雷。</span>
          </span>
        </div>
        <div class="we-can">
          <div class="skill">
            <span class="img-wrap">
              <img class="img" src="./image/76.png" alt="">
            </span>
            <span class="title">目标确认</span>
            <span class="content">提升企业认知，统一运营思维</span>
          </div>
          <div class="skill">
            <span class="img-wrap">
              <img class="img" src="./image/77.png" alt="">
            </span>
            <span class="title">需求调研</span>
            <span class="content">为企业量身设计最匹配、最合适的运营方案</span>
          </div>
          <div class="skill">
            <span class="img-wrap">
              <img class="img" src="./image/78.png" alt="">
            </span>
            <span class="title">团队打造</span>
            <span class="content">微信运营团队架构及人才培养，优化团队管理</span>
          </div>
          <div class="skill">
           <span class="img-wrap">
              <img class="img" src="./image/79.png" alt="">
            </span>
            <span class="title">方案设计</span>
            <span class="content">梳理建立微信运营流程，设定标准</span>
          </div>
          <div class="skill">
            <span class="img-wrap">
              <img class="img" src="./image/80.png" alt="">
            </span>
            <span class="title">实战培训</span>
            <span class="content">流量导流、内容运营、风险管控教学辅导</span>
          </div>
          <div class="skill">
            <span class="img-wrap">
              <img class="img" src="./image/81.png" alt="">
            </span>
            <span class="title">落地辅导</span>
            <span class="content">手把手辅导学员企业运营方案落地实施</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务 -->
    <div class="serve-trait">
      <div class="title">服务特点</div>
      <div class="serve-list">
        <div class="trait">
          <span class="trait-icon one">团队</span>
          <span class="text">超实战的老师团队，设计专属的定制化解决方案</span>
        </div>
        <div class="trait reverse">
          <span class="trait-icon two">经验</span>
          <span class="text">5年持续微营销运营实战经验，精通微信运营秘诀</span>
        </div>
        <div class="trait">
          <span class="trait-icon three">服务</span>
          <span class="text">一切以结果为导向，服务过千家国内外知名企业</span>
        </div>
        <div class="trait reverse">
          <span class="trait-icon four">满意</span>
          <span class="text">360°赋能式咨询服务，保证服务结果与客户满意</span>
        </div>
      </div>
    </div>
    <!-- 成功案例 -->
    <div class="success-case">
      <div class="text-title">成功案例</div>
      <div class="case-wrap">
        <div class="icon icon-left" @click="moveLeft"></div>
        <div class="content-wrap">
          <div class="company-wrap" :style="{marginLeft: '-'+ ((companyIndex-1)* 100)+'%'}">
            <div class="company" :key="index" v-for="(item,index) in companyList">
              <div class="icon-wrap">
                <img v-if="item.type === 1" class="img" src="./image/pingan.png" alt="">
                <img v-else-if="item.type === 2" class="img" src="./image/case5.jpg" alt="">
                <img v-else-if="item.type === 3" class="img" src="./image/case2.png" alt="">
                <img v-else class="img" src="./image/case6.jpg" alt="">
                <span class="company-name">{{item.name}}</span>
              </div>
              <div class="before-select">
                <span class="text-title">选择我们前</span>
                <span class="text-content">{{item.before}}</span>
              </div>
              <div class="line"></div>
              <div class="after-select">
                <span class="text-title">选择我们后</span>
                <span class="text-content">{{item.after}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="icon icon-right" @click="moveRight"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Index from './main'

export default {
  name: 'school',
  ...Index
}
</script>
<style lang="scss">
  @import "./index";
</style>
